import { Outlet, useNavigate } from 'react-router-dom';
import { ShieldOff } from 'lucide-react';
import useTenantFeatures from '../hooks/useTenantFeatures';

// Route guard for the Mitra One Care OPEN-PLATFORM tenant's own screens
// (MOC patient-identity administration). The counterpart of
// TenantFeatureRoute, but with the opposite failure direction on purpose:
// TenantFeatureRoute fails OPEN because hiding a paid feature on a dropped
// request is the worse outcome. Here the worse outcome is the reverse — a
// dropped request must never show a cross-tenant identity screen to an
// arbitrary hospital's admin, so this fails CLOSED (useTenantFeatures'
// isOpenPlatform defaults to false until a real answer arrives). The API's
// requireOpenPlatformAdmin is the actual boundary either way.
export default function OpenPlatformRoute({ children }) {
  const navigate = useNavigate();
  const { isOpenPlatform } = useTenantFeatures();

  if (isOpenPlatform) return children || <Outlet />;

  return (
    <div className="w-full flex items-center justify-center py-16 px-4">
      <div className="bg-white rounded-2xl shadow-md max-w-md w-full p-8 text-center">
        <div className="mx-auto mb-4 w-14 h-14 rounded-2xl bg-slate-100 text-slate-500 flex items-center justify-center">
          <ShieldOff className="w-7 h-7" />
        </div>
        <h2 className="text-xl font-bold text-[#1a365d] mb-2">Mitra One Care platform only</h2>
        <p className="text-sm text-slate-500 mb-6">
          This screen manages the Mitra One Care open-platform patient identity — it's only
          available to that tenant's admin.
        </p>
        <button
          type="button"
          onClick={() => navigate('/')}
          className="w-full px-4 py-3 rounded-xl text-white font-semibold text-sm bg-gradient-to-r from-[#4ABDBD] via-[#3AA8A8] to-[#2D8A8A] hover:shadow-lg"
        >
          Back to dashboard
        </button>
      </div>
    </div>
  );
}
